import React from "react";
import {
  NavLink,
  Switch,
  Route,
  useRouteMatch,
  useLocation,
} from "react-router-dom";
import { PatientProfileLogic } from "../index";
import {
  PageNavigation,
  RiskMedicalAnamnesis,
  PharmacologicalPlan,
  PatientHistory,
  PatientInformation,
  FtdEvaluation,
  FtdEvaluationReasonForm,
  RecordHistory,
  Anamneza,
  PenfastForm,
} from "../../components";
import { PatientRequests } from "../../components/PatientRequests/PatientRequests";
import { ComplementResults } from "../../components/ComplementResults/ComplementResults";
import { IoMdAlert } from "react-icons/io";
import { useAuth } from "../../contexts/AuthContext";
import { Penfast } from "../../components/PenfastForm/Penfast";
import "../../assets/css/complement-results.css";

export const PatientProfile = ({ ...props }) => {
  const {
    state,
    patient,
    error,
    requisitions,
    careType,
    hasPenfast,
    getPatientData,
  } = PatientProfileLogic();
  const { path, url } = useRouteMatch();
  const { checkLicense } = useAuth();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const backUrl = queryParams.get("backUrl");

  const pageTitle = location.pathname.includes("risk-medical-anamnesis")
    ? "Riziková léková anamnéza"
    : location.pathname.includes("pharmacological-plan")
    ? "Farmakologický plán"
    : location.pathname.includes("ftd-evaluation")
    ? "FTD hodnocení"
    : location.pathname.includes("record-history")
    ? "Historie záznamů"
    : location.pathname.includes("patient-information")
    ? "Informace o pacientovi"
    : location.pathname.includes("anamneza")
    ? "Anamnéza"
    : location.pathname.includes("pen-fast")
    ? "PEN-FAST"
    : location.pathname.includes("complement-results")
    ? "Výsledky komplementu"
    : location.pathname.includes("patient-history") && "Historie pacienta";

  return (
    <div>
      <h1>{pageTitle}</h1>
      <PageNavigation className="sub-page-navigation present">
        {checkLicense("height_and_weight") && (
          <div>
            <NavLink
              to={`${url}/anamneza/`}
              className={(isActive) => (!isActive ? "" : "active")}
            >
              Anamnéza
            </NavLink>
          </div>
        )}
        {careType === "hospitalization" && (
          <div>
            <NavLink
              to={`${url}/risk-medical-anamnesis/`}
              className={(isActive) => (!isActive ? "" : "active")}
            >
              Riziková léková anamnéza
            </NavLink>
          </div>
        )}
        <div>
          <NavLink
            to={`${url}/pharmacological-plan/`}
            className={(isActive) => (!isActive ? "" : "active")}
          >
            Farmakologický plán
          </NavLink>
        </div>
        {requisitions.data.length !== 0 && (
          <div>
            <NavLink
              to={`${url}/requests/`}
              className={(isActive) => (!isActive ? "" : "active")}
            >
              Žádanky pacienta ({requisitions.data.length}){" "}
              {requisitions.answer && (
                <IoMdAlert style={{ color: "#A63A49", fontSize: 20 }} />
              )}
            </NavLink>
          </div>
        )}
        {hasPenfast && checkLicense("penfast") && (
          <div>
            <NavLink
              to={`${url}/pen-fast/`}
              className={(isActive) => (!isActive ? "" : "active")}
            >
              PEN-FAST
            </NavLink>
          </div>
        )}
        {checkLicense("complement") && (
          <div>
            <NavLink
              to={`${url}/complement-results/`}
              className={(isActive) => (!isActive ? "" : "active")}
            >
              Výsledky komplementu
            </NavLink>
          </div>
        )}
        <div>
          <NavLink
            to={`${url}/ftd-evaluation/`}
            className={(isActive) => (!isActive ? "" : "active")}
          >
            FTD hodnocení
          </NavLink>
        </div>
        {patient?.patient?.cares.length > 1 && (
          <div>
            <NavLink
              to={`${url}/record-history/`}
              className={(isActive) => (!isActive ? "" : "active")}
            >
              Historie záznamů
            </NavLink>
          </div>
        )}
        <div>
          <NavLink
            to={`${url}/patient-information/`}
            className={(isActive) => (!isActive ? "" : "active")}
          >
            Informace o pacientovi{" "}
          </NavLink>
        </div>
        <div>
          <NavLink
            to={`${url}/patient-history/`}
            className={(isActive) => (!isActive ? "" : "active")}
          >
            Historie pacienta
          </NavLink>
        </div>
      </PageNavigation>
      {!state.loading && (
        <Switch>
          <Route
            path={`${path}/anamneza/`}
            component={(props) => (
              <Anamneza
                patient={patient.patient}
                careID={patient.care.id}
                getPatientCallback={getPatientData}
                {...props}
              />
            )}
          />
          <Route
            path={`${path}/risk-medical-anamnesis/`}
            component={(props) => (
              <RiskMedicalAnamnesis
                patient={patient.patient}
                riskDrugHistory={patient.care.riskdrughistory}
                careID={patient.care.id}
                careIsLocked={patient.care.is_locked}
                checkin={patient.care.checkin}
                {...props}
              />
            )}
          />
          <Route
            path={`${path}/pharmacological-plan/`}
            component={(props) => (
              <PharmacologicalPlan
                patient={patient.patient}
                plan={patient.care.pharmacologicalplan}
                care={patient.care}
                careID={patient.care.id}
                careIsLocked={patient.care.is_locked}
                checkin={patient.care.checkin}
                backUrl={backUrl}
                {...props}
              />
            )}
          />
          <Route
            path={`${path}/requests/`}
            component={(props) => (
              <PatientRequests
                requisitions={requisitions.data}
                getPatientData={getPatientData}
                patient={patient.patient}
                plan={patient.care.pharmacologicalplan}
                care={patient.care}
                careID={patient.care.id}
                careIsLocked={patient.care.is_locked}
                checkin={patient.care.checkin}
                {...props}
              />
            )}
          />
          <Route
            path={`${path}/complement-results/`}
            component={(props) => (
              <ComplementResults
                patient={patient.patient}
                care={patient.care}
                checkin={patient.care.checkin}
                isPharmaPlan={false}
                {...props}
              />
            )}
          />
          <Route
            path={`${path}/ftd-evaluation/`}
            component={(props) => (
              <FtdEvaluation
                patient={patient.patient}
                ftdEvaluation={patient.care.pharmacological_evaluations}
                careID={patient.care.id}
                careIsLocked={patient.care.is_locked}
                checkin={patient.care.checkin}
                {...props}
              />
            )}
          />
          <Route
            path={`${path}/record-history/`}
            component={(props) => (
              <RecordHistory
                patient={patient.patient}
                care={patient.care}
                checkin={patient.care.checkin}
                careIsLocked={patient.care.is_locked}
                careID={patient.care.id}
                plan={patient.care.pharmacologicalplan}
                {...props}
              />
            )}
          />
          <Route
            path={`${path}/ftd-evaluation-reason/`}
            component={(props) => (
              <FtdEvaluationReasonForm
                patient={patient.patient}
                careID={patient.care.id}
                careIsLocked={patient.care.is_locked}
                {...props}
              />
            )}
          />
          <Route
            path={`${path}/patient-information/`}
            component={(props) => (
              <PatientInformation
                patient={patient.patient}
                careID={patient.care.id}
                careIsLocked={patient.care.is_locked}
                patientInformations={patient.care.patient_informations}
                {...props}
              />
            )}
          />
          <Route
            path={`${path}/patient-history/`}
            component={(props) => (
              <PatientHistory
                patient={patient.patient}
                careID={patient.care.id}
                {...props}
              />
            )}
          />

          <Route
            path={`${path}/pen-fast/`}
            component={(props) => (
              <Penfast
                patient={patient.patient}
                care={patient.care}
                careID={patient.care.id}
                checkin={patient.care.checkin}
                {...props}
              />
            )}
          />
        </Switch>
      )}
      {error && <h2>{error.message}</h2>}
    </div>
  );
};
